const namespace = "myApp";

import AppConfig from "@/_config/application-config"
import childRoutes from "./routes"
import BrowserStorage from "@/_util/storage-modes.browser-storage";

const localStorage = new BrowserStorage(namespace);
const sessionStorage = new BrowserStorage(namespace, true);

const appConfig = {
  // "namespace" : {
  name: "My App",
  namespace,
  description: null,
  version: "0.1.0",
  icon: "mdi-gauge",
  parentRoute: "/my-app",
  defaultRoute: "helloworld",
  accentColor: "#000080",
  childRoutes,
  component : () => import(/* webpackChunkName: "myapp-parent" */ "@/apps/my-app/Application.vue"),
  navigation: [{
      title: "Hello World",
      route: "helloworld",
      icon: "mdi-hand",
    },
    {
      title: "Help",
      route: "help",
      icon: "mdi-help-circle",
    },
    {
      title: "Config",
      route: "config",
      icon: "mdi-hammer-wrench",
    },
  ],
  settings : {},
  store: {
    //The store is made up of settings and attributes that should be accessible across components.
    //One common scenario would be user settings or profile preferences.  Some examples:
    //Date and Time Formats
    //Preferred configuration of a table view
    //Preferred theme color.
    themeColor : {
      default: "red",
      storageMode : localStorage,
    },
    isTrue : {
      default: true,
      storageMode : sessionStorage,
    },
  }

}

export default AppConfig.merge(appConfig);


